import { Box, Stack, Typography, useTheme } from "@mui/material";
import { CircularLoader } from "components";
import { DownloadBtn } from "./DownloadBtn";

export const QrCodeComponent = ({
  qrCode,
  closeDownloadDrawer,
  isLoading = false,
  isError = false,
  onRetry,
}: {
  qrCode: string;
  closeDownloadDrawer?: () => void;
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: () => void;
}) => {
  const theme = useTheme();

  const renderQrContent = () => {
    if (isLoading) {
      return (
        <Stack
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
          border={`1px solid ${theme.palette.neutral["010"]}`}
        >
          <CircularLoader size={24} />
        </Stack>
      );
    }

    if (isError && onRetry) {
      return (
        <Stack
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
          borderRadius="4px"
          bgcolor={theme.palette.neutral["005"]}
          sx={{ cursor: "pointer" }}
          onClick={onRetry}
        >
          <Typography variant="button-label" color="primary.main">
            Regenerate
          </Typography>
        </Stack>
      );
    }

    return (
      <img
        style={{
          width: "100%",
          height: "100%",
          backgroundRepeat: "no-repeat",
          objectFit: "contain",
          marginLeft: "-6px",
        }}
        src={qrCode}
        alt="qr code"
      />
    );
  };

  return (
    <Stack
      gap="16px"
      sx={{
        minWidth: "154px",
        maxWidth: "312px",
        width: "50%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          aspectRatio: 1,
        }}
      >
        {renderQrContent()}
      </Box>
      <Typography variant="body-medium" color="lightBg.low">
        Use your phone to scan the QR code and download the app.
      </Typography>
      {closeDownloadDrawer && (
        <DownloadBtn
          variant={"teams"}
          closeDownloadDrawer={closeDownloadDrawer}
        />
      )}
    </Stack>
  );
};
